import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockOrderInfoNotify = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderInfoNotifyRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderInfoNotifyResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoNotifyRequest.xml'} title={t('Пример запроса') + ' ' + t('Размещение')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoNotifyResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Размещение')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoNotifyGainRequest.xml'} title={t('Пример запроса') + ' ' + t('Агентские договора с доп.выгодой')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoNotifyResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Агентские договора с доп.выгодой')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoNotifyResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockOrderInfoNotify;